<template>
  <span />
</template>
<script>
import axios from 'axios';
import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'TagManager',
  data() {
    return {
      gtmData: null
    };
  },
  computed: {
    events() {
      return this.$store.state.Events.stateGtmData;
    }
  },
  watch: {
    events: {
      handler() {
        if (this.$store.state.Events.stateGtmData.length > 0) {
          this.sendToGTM();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getMemberStatus();
  },
  methods: {
    sendToGTM() {
      if (this.events.length > 0) {
        Utility.pushToTagManager(this.events[0]);
        /* eslint-disable no-console */
        this.$store.commit('Events/RESET_GTM_DATA', {});
        this.sendToGTM();
      }
    },
    getMemberStatus() {
      axios
        .get(Utility.constants().API.member_isloggedin_newmember)
        .then((response) => {
          Utility.pushToTagManager({
            memberStatus: response.data
          });
        })
        .catch((err) => {
          Utility.logError(err, this);
        });
    }
  }
};
</script>
